<template>
  <div id="app" class="layout">
    <Sidebar />
    <CookieWall />
    <main class="content">
      <router-view />
    </main>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Sidebar from "./components/SidebarView.vue";
import CookieWall from "@/components/CookieWall.vue";

export default defineComponent({
  components: { Sidebar, CookieWall },
});
</script>

<style>
/* Layout container: sidebar + content */
.layout {
  display: flex;
  min-height: 100vh;
}

/* Main content area */
.content {
  flex: 1; /* take remaining space */
  display: flex;
  justify-content: center; /* center inner content horizontally */
  padding: 2rem 0;
}

/* Inner wrapper to limit width */
.content > * {
  width: 66%; /* 2/3 width */
  max-width: 1100px; /* prevents huge screens from stretching */
  margin: 0 auto;
  text-align: left; /* optional: avoids everything being centered */
}

/* Existing styles */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
